/* ══════════════════════════════════════════════════════════════════════
   一周年感謝祭 ティザー（ファサード＋CONCEPT）
   sections/anv-teaser-facade.liquid ／ anv-teaser-concept.liquid 専用。

   出どころ: design/archive/mocks/site-v20/assets/section-anv-teaser.js。
   Shopify 化にあたって足したのは、OS2.0 のセクション再レンダ対策だけ:
     - shopify:section:load / :unload への配線
     - tick() の isConnected 自己修復ガード（unload が飛ばない経路でも detached ループを止める）
   （docs/anv-motion-spike.md リスク#2 の対策。スパイクで有効性を確認済み）

   規律（CLAUDE.md コーディング規約 JavaScript）:
     - IIFE でファイルスコープに閉じる。グローバルへ何も生やさない
     - DOM のフックは data-* 属性（id には依存しない＝セクションが複数置かれても壊れない）
     - Focal の既存カスタムイベント（variant:changed 等）には触らない。独自イベントも新設しない
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── ① ピンの進捗 --p ─────────────────────────────────────────────
     ファサードは 340vh（SP 200vh）の sticky。スクロール量を 0→1 に正規化した --p が
     夜景から館内への着床を駆動する。lerp（係数 .12）で1フレーム遅れの粘りを出す。
     reduce 時はアニメーションさせず、冒頭（0）で据え置く。 */
  var loops = new WeakMap();

  function startPin(pin) {
    if (loops.has(pin)) return;
    if (reduce) {
      pin.style.setProperty('--p', 0);
      pin.classList.add('anv-t-done');
      return;
    }
    var current = -1;
    var state = { alive: true };
    loops.set(pin, state);
    (function tick() {
      /* 自己修復ガード: セクションが外されたら（unload が飛ばなくても）ループを畳む */
      if (!state.alive || !pin.isConnected) { loops.delete(pin); return; }
      var total = pin.offsetHeight - innerHeight;
      var target = total > 0 ? Math.min(1, Math.max(0, -pin.getBoundingClientRect().top / total)) : 0;
      current = current < 0 ? target : current + (target - current) * 0.12;
      if (Math.abs(target - current) < 0.0005) current = target;
      pin.style.setProperty('--p', current.toFixed(4));
      requestAnimationFrame(tick);
    })();
  }

  function stopPin(pin) {
    var state = loops.get(pin);
    if (state) { state.alive = false; loops.delete(pin); }
  }

  /* ── ② 着地リビール ───────────────────────────────────────────────
     arrival-once（発火後 unobserve＝戻っても再アニメしない）。reduce 時は武装せず既定＝完成形。
     ⚠️ threshold は 0 でなければならない。line リビールは自身を clip-path で潰すため
        intersectionRatio が常に 0 になり、.12 だと発火せず見出しが永久に隠れる（Chromium 実測）。 */
  function armReveals(root) {
    if (reduce) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('anv-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
    root.querySelectorAll('[data-rv]').forEach(function (el) { io.observe(el); });
  }

  /* ── ③ ファサードの boot ──────────────────────────────────────────
     reduce 時は演出を飛ばして完成形で止め、poster を最終フレーム（今年の秋）へ差し替える。
     動画は loop させない＝1回だけ再生して最終フレームで静止する。 */
  function bootFacade(facade) {
    var video = facade.querySelector('video');
    function settle() {
      facade.classList.remove('anv-t-booting');
      facade.classList.add('anv-t-booted');
    }
    if (reduce) {
      if (video) {
        video.pause();
        video.removeAttribute('autoplay');
        var still = video.getAttribute('data-poster-still');
        if (still) video.poster = still;
      }
      settle();
      facade.classList.add('anv-t-settled');
      return;
    }
    if (video) {
      var play = video.play();
      if (play && play.catch) play.catch(function () {});
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        settle();
        setTimeout(function () { facade.classList.add('anv-t-settled'); }, 1100);
      });
    });
  }

  /* ── ④ アンカーの平滑スクロール（ファサード右下の SCROLL）────────── */
  function armAnchors(root) {
    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      a.addEventListener('click', function (e) {
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  function init(root) {
    root.querySelectorAll('[data-anv-t-pin]').forEach(startPin);
    root.querySelectorAll('[data-anv-t-facade]').forEach(bootFacade);
    armReveals(root);
    armAnchors(root);
  }

  function teardown(root) {
    root.querySelectorAll('[data-anv-t-pin]').forEach(stopPin);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* OS2.0 テーマエディタでの追加・並べ替え・削除に追従する */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
})();
